import CostAnalysisReportChildTableRow from './CostAnalysisReportChildTableRow'

const CostAnalysisReportChildTable = ({childData, minVariantCostPrice}: any) => {
  return (
    <div className='card-body p-0'>
      <div className='table-responsive position-relative'>
        <table className='table gs-0 gy-3 align-middle my-3 table-row-bordered border'>
          <thead className='fw-semibold bg-light text-uppercase'>
            <tr className='text-gray-700 text-uppercase'>
              <th className='min-w-80 w-80px'></th>
              <th className='min-w-500px w-500px'>Product Name</th>
              <th className='min-w-150px w-150px'>SKU</th>
              <th className='min-w-150px w-150px'>Current Cost</th>
              <th className='min-w-175px w-175px'></th>
              <th className='min-w-150px w-150px'>Last PO Cost</th>
              <th className='min-w-225px w-225px'>Avg. Cost of Last 3 POs</th>
              <th className='min-w-150px w-150px'>Last 3 PO Details</th>
            </tr>
          </thead>
          <tbody>
            {childData.map((child: any, index: number) => (
              <CostAnalysisReportChildTableRow key={index} row={child} minVariantCostPrice={minVariantCostPrice} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CostAnalysisReportChildTable
